import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

import zIndices from 'pubweb-smokey/dist/components/zIndex';

export const AnchoredModalStyles = styled.div`
  position: relative;
  width: 100%;

  .page-overlay {
    background-color: #000;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: ${(props) => (props.pageOverlayOffset ? props.pageOverlayOffset : 0)};
    width: 100%;
    z-index: ${zIndices.anchorModal};
  }
  .modal-window {
    background-color: #fff;
    border-radius: 4px;
    padding-top: 20px;
    position: absolute;
    top: 0;
    width: 270px;
    z-index: ${zIndices.anchorModalContent};

    .anchored-modal-content {
      max-height: 280px;
      overflow-y: ${(props) => (props.showOverflow ? 'visible' : 'auto')};
      padding: 0 20px;
      -webkit-overflow-scrolling: touch;
    }

    .anchored-modal-content::-webkit-scrollbar,
    .anchored-modal-content::-webkit-scrollbar,
    .anchored-modal-content::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 5px;
    }

    .anchored-modal-content::-webkit-scrollbar-thumb,
    .anchored-modal-content::-webkit-scrollbar-thumb,
    .anchored-modal-content::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: lightgray;
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }

    .bottom-controls {
      border-top: solid 1px ${Colors.primary.black.tint};
      display: flex;
      justify-content: space-between;
      padding: 10px;
    }
  }

  &.auto-position {
    position: static;

    .page-overlay {
      height: 100vh;
      left: 0;
      position: absolute;
      top: 100%;
      width: 100%;
    }

    .modal-window {
      left: 0;
      top: 100%;
    }
  }
`;
